// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-remover-data[data-v-948c5a16]{position:relative;z-index:1}.dias-semana-wrapper[data-v-948c5a16]{margin-bottom:10px}.form-checkbox-item+.form-checkbox-item[data-v-948c5a16]{margin-top:0}.form-checkbox-label>label *[data-v-948c5a16]{display:block}", ""]);
// Exports
module.exports = exports;
